import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// @ts-ignore
import styled from "./MenuUserActionSection.module.css";
import Profile from "../profile/Profile";
import LocalSwitcher from "../LocalSwitcher/LocalSwitcher";
import NotificationBell from "../NotificationBell/NotificationBell";
import BirthdayBell from "../BirthdayBell/BirthdayBell";
import { WhatsAppIcon } from "../../models/icons";
import { IAccountInfo } from "@Models/interfaces/account";
// 010: gating del tenant HQ de Prikly (bandeja de soporte)
import { getHqAccess } from "../../../support/services/supportApi";

const MenuUserActionSection = () => {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [isHq, setIsHq] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Solo el tenant configurado en SUPPORT_HQ_COMPANY_ID recibe true
    getHqAccess().then(setIsHq);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Función para generar el enlace de WhatsApp
  const generateWhatsAppLink = () => {
    const phoneNumber = "+51905453587";
    const account_info: IAccountInfo = JSON.parse(
      localStorage.getItem("account_info") || '{}'
    ) as IAccountInfo;

    const employeeName = account_info?.employee?.name || '';
    const employeeLastName = account_info?.employee?.lastName || '';
    const companyName = account_info?.lounge?.name || '';

    const message = encodeURIComponent(
      `Hola, soy ${employeeName} ${employeeLastName} de la empresa ${companyName} y necesito ayuda por favor.`
    );
    return `https://wa.me/${phoneNumber}?text=${message}`;
  };

  return (
    <article className={styled.menuUserActionSection__article}>
      <LocalSwitcher />
      <NotificationBell />
      <BirthdayBell />
      {isHq && (
        <button
          onClick={() => navigate("/soporte-hq")}
          title="Soporte Prikly (HQ)"
          aria-label="Bandeja de soporte de Prikly"
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            fontSize: "18px",
            padding: "4px 6px",
          }}
        >
          🛟
        </button>
      )}
      <button
        className={styled.whatsappButton}
        onClick={() => window.open(generateWhatsAppLink(), "_blank")}
      >
        <div className={styled.whatsappButtonContent}>
          <img
            src={WhatsAppIcon}
            alt="WhatsApp"
            className={styled.whatsappIcon}
          />
          <span>¿Necesitas ayuda?</span>
        </div>
      </button>
      <Profile width={screenWidth} />
    </article>
  );
};

export default MenuUserActionSection;
